import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActionBarService {
  public searchOptions: { enabled?: boolean, advanced?: boolean, initialStateOfAdvanced?: boolean } = {};
  public search$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public advancedFilter$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public addClick$: Subject<void> = new Subject<void>();
  public addState$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public buttonClick$: Subject<string | {action: string, data: any}> = new Subject<string | {action: string, data: any}>();
  public saveClick$: Subject<void> = new Subject<void>();
  public saveState$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public isForceSaveShown$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public deleteClick$: Subject<void> = new Subject<void>();
  public deleteState$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public buttonClickState$: Subject<{action: string, state: any}> = new Subject<{action: string, state: any}>();
  public entityState$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor() {
  }

  triggerChanges(isPristine: boolean = true) {
    this.addState$.next(isPristine);
    this.saveState$.next(isPristine);
  }
}
